import React, { useEffect, useState,useRef } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowsAlt,
} from "@fortawesome/free-solid-svg-icons";
import Wrench from "../../assets/wrench";
import TableIcon from "../../assets/TableIcon";
import AlertHexagon from "../../assets/alertHexagon";
import ElevProfileWidget from '../../widgets/esri/elevation-profile/ElevProfileWidget';
import TimeChartWidget from '../../widgets/custom/time-chart/TimeChartWidget';
import Table from '../../widgets/custom/table-panels/TableMui';
import { ISelectionDataModel } from '../../hooks/context/SelectionDataContext';
import useTablesDataHook from '../../widgets/custom/table-panels/useTablesDataHook';
import TableDataGrid from '../../widgets/custom/table-panels/TableDataGrid';
import IconButton from '@mui/material/IconButton';
import { Fullscreen } from '@mui/icons-material';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { TablePagination } from '@mui/material';
import TablePanels from '../../widgets/custom/table-panels/TablePanels';
import SelectTablePagination from '../../widgets/custom/table-panels/SelectTablePagination';
import SurveyRefWidget from '../../widgets/custom/survey-reference/SurveyRefWidget';

const HorizPanel = ({view, setShowFullScreen,showFullScreen,pageConfig,layerIds}) => {

    const toolNames=useRef(activateHorizontalWidgets(pageConfig.widgets))
    const [bottomPanelMode, setBottomPanelMode] = useState('tools')
    const [currentTool,setCurrentTool]=useState(toolNames.current[0].name)
    const[currentTableName,setCurrentTableName]=useState("")
    const payload: ISelectionDataModel | any = useTablesDataHook()
    
    useEffect(()=>{
       const toolNamesFilter=toolNames.current.filter(tool=>{
            return tool.name===currentTool
        })[0];
        const payloadFilter=payload.filter((table)=>{
          return table.layerName===currentTableName
        })
        if(!payloadFilter.length){
          if(payload.length){
            setCurrentTableName(payload[0].layerName)
          }else{
            setCurrentTableName("")
          }
        }
        if(payload.length<toolNamesFilter.minSelectRequired){

            setCurrentTool(toolNames.current[0].name)
        }
        if(payload.length>0){
          setBottomPanelMode('table')
          if(!currentTableName){
            setCurrentTableName(payload[0].layerName)
          }
        }
        if(!payload.length){
          setCurrentTableName("")
          setBottomPanelMode('tools')
        }

    },[payload])

  return (
    <>
    <div className="noselect survey__tab-row">
    <div className="survey__tab-col">
      <div
        className="survey__tab__icon"
        style={{ marginRight: "1rem" }}
        onClick={() => {
            if(bottomPanelMode==='table'){
                setBottomPanelMode('tools')
            }else{
                if(payload?.length>0){
                setBottomPanelMode('table')
                }
            }}}>
        {bottomPanelMode === 'table' && payload.length>0 ? <div><p className="title">Tools</p><Wrench /></div> :""}
        {bottomPanelMode === 'tools' && payload.length>0 ? <div><p className="title">Tables</p><TableIcon /></div> :""}
        {bottomPanelMode === 'tools' && !payload.length ? <div><p style={{color:'red'}} className="title">Tables</p><AlertHexagon/></div>:"" }

      </div>

      
        {bottomPanelMode === 'tools' ?
        toolNames.current.map(tool=>{
            if(payload.length>=tool.minSelectRequired){
                return(<div key={tool.name}><div className={
                    currentTool === tool.name
                      ? "survey__tab survey__tab--selected"
                      : "survey__tab"
                  } onClick={()=>setCurrentTool(tool.name)}> {tool.name}</div></div>)

            }else{
                return""
            }
    }):""}
      
      <TablePanels payload={payload} panelMode={bottomPanelMode} currentTableName={currentTableName} setCurrentTableName={setCurrentTableName}/>

    </div>
    <div  className="survey__tab-col">
    <IconButton title={!showFullScreen?'full-screen':'exit full-screen'}  onClick={() => setShowFullScreen(!showFullScreen)}>
      {!showFullScreen?<Fullscreen color='primary'/>:<FullscreenExitIcon color='primary'/>}
      </IconButton>
      </div>
  </div>

  <div
    className="scroll scroll--alt table-cont"
  >
    <div
      style={
        bottomPanelMode === "table"
          ? { display: "block" }
          : { display: "none" }
      }
    >
    <SelectTablePagination view={view}payload={payload} currentTableName={currentTableName}/>
    </div>

    <div
      style={
        bottomPanelMode === "tools"
          ? { display: "block" }
          : { display: "none" }
      }
    >
        {pageConfig.widgets.elevProfile.show &&<ElevProfileWidget view={view} activeWidget={currentTool} />}
        {pageConfig.widgets?.surveyRef?.show &&<SurveyRefWidget view={view} activeWidget={currentTool} layerIds={layerIds}></SurveyRefWidget>}
        {pageConfig.widgets.timeChart.show&&<>{payload?.length>0?<TimeChartWidget view={view} activeWidget={currentTool} />:""}</>}
    </div>
  </div>
</>

  )
}

export default HorizPanel

const activateHorizontalWidgets=(widgets):any[]=>{
  let tools=[]
  for(const [key,value] of Object.entries(widgets)as any){
    
    if(value?.show && value?.widgetLocation==='horizontal'){
      if(value?.minSelectRequired){
        tools.push({name:value?.name,minSelectRequired:value.minSelectRequired})
      }
      else{
        tools.push({name:value?.name,minSelectRequired:0})
      }
      
    }
  }
  return tools
}